export function combineVariableWithCustomField(templateSettings) {
  const customField = templateSettings.find((item) => item.type === 'custom_field')
  const variable = templateSettings.find((item) => item.type === 'variable')

  if (customField && variable) {
    customField.additional_settings['variables'] = variable.additional_settings['variables']
    return templateSettings.filter((item) => item.type !== 'variable')
  } else {
    return templateSettings
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/EmbeddingCyclrIntegration/utils.js